import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const YearContext = createContext();

export function YearProvider({ children }) {
  const [selectedYear, setSelectedYear] = useState(() => {
    // Charger l'année depuis le localStorage ou utiliser l'année courante
    const savedYear = localStorage.getItem('selectedYear');
    return savedYear ? parseInt(savedYear, 10) : new Date().getFullYear();
  });

  const [availableYears, setAvailableYears] = useState(() => {
    // Charger les années disponibles depuis le localStorage
    const savedYears = localStorage.getItem('availableYears');
    if (savedYears) {
      return JSON.parse(savedYears);
    }
    // Par défaut, générer 5 années autour de l'année courante
    const currentYear = new Date().getFullYear();
    return [...Array(5)].map((_, i) => currentYear - 2 + i);
  });

  // Sauvegarder l'année sélectionnée dans le localStorage à chaque changement
  useEffect(() => {
    if (selectedYear != null) {
      localStorage.setItem('selectedYear', selectedYear.toString());
    }
  }, [selectedYear]);

  // Sauvegarder les années disponibles dans le localStorage
  useEffect(() => {
    localStorage.setItem('availableYears', JSON.stringify(availableYears));
  }, [availableYears]);

  const updateAvailableYears = useCallback((newYears) => {
    // Remplacer les années disponibles (toutes les pages utilisent la même source : temps + année courante)
    setAvailableYears([...newYears].sort((a, b) => b - a));
  }, []);

  return (
    <YearContext.Provider value={{
      selectedYear,
      setSelectedYear,
      availableYears,
      setAvailableYears: updateAvailableYears
    }}>
      {children}
    </YearContext.Provider>
  );
}

export function useYear() {
  const context = useContext(YearContext);
  if (context === undefined) {
    throw new Error('useYear must be used within a YearProvider');
  }
  return context;
}
